module.exports = __webpack_public_path__ + "static/media/wellness@2x.1e2a114a.jpg";